import AppSidebar from "@/components/AppSidebar";
import {
  SidebarInset,
  SidebarProvider,
  SidebarTrigger,
} from "@/components/ui/sidebar";
import { Outlet } from "react-router";
import { useUser } from "@/hooks/useUser.ts";
import { useHeader } from "@/hooks/useHeader.ts";
import { Separator } from "@/components/ui/separator.tsx";
import { useIsMobile } from "@/hooks/use-mobile.ts";
import Footer from "@/components/Footer.tsx";
import { ScrollArea } from "@/components/ui/scroll-area.tsx";
import { Button } from "@/components/ui/button.tsx";
import { Bell } from "lucide-react";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover.tsx";
import Notifications from "@/components/Notifications.tsx";
import ThemeSwitch from "@/components/ThemeSwitch.tsx";
import { useTranslation } from "@/i18n";

const DesktopLayout = () => {
  const user = useUser();
  const header = useHeader();
  const isSmallScreen = useIsMobile();
  const { t } = useTranslation();

  return (
    <SidebarProvider className="flex flex-col">
      <div className="flex h-screen flex-1">
        {!!user && <AppSidebar />}
        <SidebarInset className="flex h-screen">
          <header className="bg-sidebar text-sidebar-foreground flex h-16 shrink-0 items-center gap-2 border-b">
            <div className="flex w-full items-center gap-2 px-4">
              {!!user && isSmallScreen && (
                <>
                  <SidebarTrigger className="-ml-1" />
                  <Separator orientation="vertical" className="mr-2 h-4" />
                </>
              )}
              <h1 className="text-xl">{header.title}</h1>
              <div className="ml-auto">
                <ThemeSwitch />
                {!!user && (
                  <Popover>
                    <PopoverTrigger asChild>
                      <Button variant="ghost" size="icon">
                        <Bell className="size-5" />
                        <span className="sr-only">
                          {t("nav.notifications")}
                        </span>
                      </Button>
                    </PopoverTrigger>

                    <PopoverContent className="w-96">
                      <ScrollArea>
                        <Notifications className="max-h-[50vh]" />
                      </ScrollArea>
                    </PopoverContent>
                  </Popover>
                )}
              </div>
            </div>
          </header>
          <ScrollArea className="size-full overflow-auto">
            <div className="flex h-full flex-1 flex-grow flex-col gap-4 p-4">
              <Outlet />
            </div>
          </ScrollArea>
          <Footer />
        </SidebarInset>
      </div>
    </SidebarProvider>
  );
};

export default DesktopLayout;
